// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Box, Chip } from '@mui/material';
import { InstrumentIdentifier } from '@daml.js/utility-registry-holding-v0/lib/Utility/Registry/Holding/V0/Types';
import PartyDisplay from '../../components/PartyDisplay';

interface InstrumentIdentifiersProps {
  instrumentIdentifiers: InstrumentIdentifier[];
  enableWrap?: boolean;
}

const InstrumentIdentifiers: React.FC<InstrumentIdentifiersProps> = ({
  enableWrap,
  instrumentIdentifiers,
}) => {
  return (
    <Box sx={{ display: 'flex', flexWrap: enableWrap ? 'wrap' : 'nowrap' }}>
      {instrumentIdentifiers.map((instrumentIdentifier, index) => {
        return (
          <Box
            key={
              instrumentIdentifier.source + instrumentIdentifier.id + instrumentIdentifier.scheme
            }
          >
            <Chip size="small" label={<PartyDisplay party={instrumentIdentifier.source} />} />
            <Chip size="small" label={instrumentIdentifier.id} />
            <Chip size="small" label={instrumentIdentifier.scheme} />
            {index < instrumentIdentifiers.length - 1 && ' ∧ '}
          </Box>
        );
      })}
    </Box>
  );
};

export default InstrumentIdentifiers;
